import { getClient } from "./axiosClient";

const client = getClient();

export async function getTrialInfo(companyId){
    return await client.get(`v1/trial/company/${companyId}`);
}

export async function convertTrialToPaid(companyId){
    return await client.post(`v1/trial/convert/company/${companyId}`);
}

export async function extendTrialPeriod(companyId, {creditsToAdd, newExpiry}){
    return await client.post(`v1/trial/extend/company/${companyId}`,
        {
            additionalCredits: creditsToAdd,
            newEndDate: newExpiry,
        }
    );
}